import React from 'react'
import Select, {ActionMeta, PropsValue, SingleValue} from 'react-select'

interface Props {
	value: PropsValue<{ value: string, label: string }> | undefined
	onChange: ((newValue: SingleValue<{ value: string, label: string }>, actionMeta: ActionMeta<{
		value: string,
		label: string
	}>) => void) | undefined
	isLoading?: boolean
	onBlur?:  React.FocusEventHandler<HTMLInputElement> | undefined
	options: { value: string, label: string }[] | undefined
	name?: string
	isDisabled?: boolean
	isError?: boolean
}

const Selector: React.FC<Props> = ({value, onChange, options, onBlur, isLoading, name, isDisabled, isError}) => {
	return (
		<Select
			isDisabled={isDisabled}
			name={name}
			styles={{
				control: (base, {isDisabled}) => ({
					...base,
					backgroundColor: 'var(--bs-body-bg)',
					color: isError ? '#ff4640' : 'var(--bs-body-color)',
					borderColor: isError ? '#ff4640' : 'var(--bs-border-color)',
					opacity: isDisabled ? 0.5 : 1,
				}),
				singleValue: (base) => ({
					...base,
					color: isError ? '#ff4640' : 'var(--bs-body-color)',
				}),
				input: (base) => ({
					...base,
					color: 'var(--bs-body-color)',
				}),
				menuList: (base) => ({
					...base,
					backgroundColor: 'var(--bs-body-bg)',
					color: 'var(--bs-body-color)',
					borderColor: 'var(--bs-border-color)',
				}),
				option: (styles, { isDisabled, isFocused, isSelected }) => {
					return {
						...styles,
						backgroundColor: isSelected
							? 'var(--bs-link-hover-color)'
							: undefined,
						color: isSelected
							? 'var(--bs-body-bg)' : isFocused ? 'var(--bs-link-hover-color)'
								: 'var(--bs-body-color)',
						cursor: isDisabled ? 'not-allowed' : 'pointer',
						':active': {
							...styles[':active'],
							backgroundColor: isSelected
								? 'var(--bs-link-active-bg)'
								: undefined,
						},
					}
				}
			}}
			value={value}
			onChange={onChange}
			isLoading={isLoading}
			isSearchable
			onBlur={onBlur}
			options={options}
		/>
	)
}

export default Selector